/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SharedHotelTextSection
 */
export interface SharedHotelTextSection {
  /**
   *
   * @type {string}
   * @memberof SharedHotelTextSection
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof SharedHotelTextSection
   */
  text?: string;
}

/**
 * Check if a given object implements the SharedHotelTextSection interface.
 */
export function instanceOfSharedHotelTextSection(
  value: object
): value is SharedHotelTextSection {
  return true;
}

export function SharedHotelTextSectionFromJSON(
  json: any
): SharedHotelTextSection {
  return SharedHotelTextSectionFromJSONTyped(json, false);
}

export function SharedHotelTextSectionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SharedHotelTextSection {
  if (json == null) {
    return json;
  }
  return {
    title: json["title"] == null ? undefined : json["title"],
    text: json["text"] == null ? undefined : json["text"],
  };
}

export function SharedHotelTextSectionToJSON(
  json: any
): SharedHotelTextSection {
  return SharedHotelTextSectionToJSONTyped(json, false);
}

export function SharedHotelTextSectionToJSONTyped(
  value?: SharedHotelTextSection | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    title: value["title"],
    text: value["text"],
  };
}
